import { render, staticRenderFns } from "./ServicePricing.vue?vue&type=template&id=4ae587be"
import script from "./ServicePricing.vue?vue&type=script&lang=js"
export * from "./ServicePricing.vue?vue&type=script&lang=js"
import style0 from "./ServicePricing.vue?vue&type=style&index=0&id=4ae587be&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports